<template>
  <v-lazy 
    :min-height="200" 
    :options="{ threshold: 0.5 }" 
    transition="fade-transition"
  >
    <div>
      <h2 class="text-h5 font-weight-bold mb-4">You might also like</h2>
      <v-row>
        <v-col
          v-for="item in items" 
          :key="item.code"
          cols="12" 
          xs="12" 
          sm="6" 
          md="4" 
          lg="4"
        >
          <listing-item-card :item="item" hideChips />
        </v-col>
        
        <v-col cols="12" v-if="items.length === 0">
          <v-sheet class="pa-4 text-center">
            <v-icon size="large" color="grey">mdi-information</v-icon>
            <p class="text-body-1 text-grey mt-2">No related listings available</p>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </v-lazy>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    required: true
  }
});

// Add error handling
const hasError = ref(false);
const errorMessage = ref('');

onMounted(() => {
  if (!props.items || props.items.length === 0) {
    hasError.value = true;
    errorMessage.value = 'Unable to load suggested listings';
  }
});
</script> 